export const validation = {
  maxParagraphChar: 2000
}